import axios, {AxiosResponse} from "axios";
import {APIS} from "../../../../static/apis";

export function deleteCompanyService (companyId: string): Promise<AxiosResponse<{ data: boolean }>> {
  return axios.delete(
    APIS.BASE_AUTH_MS_URL + APIS.DELETE_COMPANY,
    { params: { companyId } }
  );
}
